// extracted by mini-css-extract-plugin
export default {"h1":"InputField_h1__eLwfh","h2":"InputField_h2__3r+kv","h3":"InputField_h3__whc77","regular":"InputField_regular__7F9u2","InputField_Error":"InputField_InputField_Error__RLfHI"};